// Pure helper: roll a sequence's enrollments into status counts for the
// summary chips on the sequence page.
export function summarizeEnrollments(enrollments) {
  const out = { total: 0, active: 0, completed: 0, cancelled: 0 };
  (enrollments || []).forEach((e) => {
    out.total += 1;
    if (e && Object.prototype.hasOwnProperty.call(out, e.status)) {
      out[e.status] += 1;
    }
  });
  return out;
}
